import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import mock from '../utils/mock';

export interface DeleteUserTenantParams {
  userId: string;
  tenantId: string;
}

const deleteUserTenant: MutationFunction<
  boolean,
  DeleteUserTenantParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockDeleteUserTenant().success, {
      delay: 1000,
      failureRate: 0,
    });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/shared/users/${args.userId}/allowed-tenants/${args.tenantId}`,
    {
      method: 'DELETE',
    },
  );
  if (response.status !== 204) {
    throw new Error('Failed to delete user tenant');
  }
  return true;
};

const _mockDeleteUserTenant = () => ({
  success: true,
});

export default deleteUserTenant;
